import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import StyledButton from "../../../../../UIcomponent/Button";
import Container from "./Container";

function Certificate(props) {
  const { certificates = [], moveData } = props;
  const inputRef = useRef();
  const [state, setState] = useState({
    data: certificates || [],
    modal: { isOpen: false, editMode: false, selectedIndex: null },
  });

  const closeModal = () => {
    setState({
      ...state,
      modal: {
        editMode: false,
        isOpen: false,
        selectedIndex: null,
      },
    });
  };

  const openModalEditMode = (index) => {
    setState({
      ...state,
      modal: {
        editMode: true,
        selectedIndex: index,
        isOpen: true,
      },
    });
  };

  const openModal = (index) => {
    setState({
      ...state,
      modal: {
        ...state.modal,
        isOpen: true,
      },
    });
  };

  const removeItem = () => {
    setState({
      ...state,
      data: state.data.filter((item, i) => i !== state.modal.selectedIndex),
      modal: {
        editMode: false,
        isOpen: false,
        selectedIndex: null,
      },
    });
    moveData(state.data.filter((item, i) => i !== state.modal.selectedIndex));
  };

  const done = () => {
    let newData = state.data;
    if (state.modal.editMode) {
      newData[state.modal.selectedIndex].title = inputRef.current.value;
      newData[state.modal.selectedIndex].verified = false;

      setState({
        data: newData,
        modal: {
          editMode: false,
          isOpen: false,
          selectedIndex: null,
        },
      });
    } else {
      newData.push({
        title: inputRef.current.value,
        verified: false,
      });
      setState({
        data: newData,
        modal: {
          editMode: false,
          isOpen: false,
          selectedIndex: null,
        },
      });
    }
    moveData(state.data);
  };

  return (
    <>
      <Container>
        <div className="sub-title-bar">
          <h4>مدارک</h4>
        </div>

        <div className="list">
          {state.data.map((item, index) => {
            return (
              <div
                onClick={() => openModalEditMode(index)}
                className={`${
                  item.verified ? "verified" : "not-verified"
                } item`}
              >
                <div className="title">{item.title}</div>
                <div className="verify-text">
                  ({item.verified ? "تایید شده" : "تایید نشده"})
                </div>
              </div>
            );
          })}
        </div>
        <br />
        <StyledButton onClick={openModal} primary>
          اضافه کردن +
        </StyledButton>
      </Container>
      <Dialog
        maxWidth={"xs"}
        fullWidth="xs"
        open={state.modal.isOpen}
        onClose={closeModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {state.modal.editMode ? "ویرایش مدارک" : "اضافه کردن مدرک"}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth="xs"
            defaultValue={
              state.modal.editMode
                ? state.data[state.modal.selectedIndex].title
                : ""
            }
            inputRef={inputRef}
            id="outlined-basic"
            label="نام مدرک"
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button style={{ marginLeft: "auto" }} onClick={closeModal}>
            لغو
          </Button>
          <div>
            <Button
              onClick={removeItem}
              style={{ margin: 5 }}
              variant="contained"
            >
              حذف
            </Button>
            <Button onClick={done} variant="contained" color="primary">
              ثبت
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Certificate;
